module.exports = __webpack_public_path__ + "img/voiss-start.cb4b59b3.png";